import React from 'react';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { sa } from '../../components/superAdminUi';

const pageSizeOptions = [10, 20, 50, 100];

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  font-family: ${sa.font.family};
  font-size: 13px;
  color: ${sa.color.textGray};

  select {
    font-family: ${sa.font.family};
    font-size: 13px;
    color: ${sa.color.text};
    border: 1px solid ${sa.color.stroke};
    border-radius: ${sa.radius.sm};
    padding: 4px 8px;
    cursor: pointer;
  }

  strong {
    color: ${sa.color.text};
  }
`;

const Paging = ({ pageCount, pageNo, pageSize, onPageChange }) => {
  if (!pageCount || pageCount < 1) return null;

  return (
    <Bar>
      <label>
        Row per page:{' '}
        <select
          value={pageSize}
          onChange={(e) => onPageChange(1, Number(e.target.value))}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>
      <span>
        Page <strong>{pageNo}</strong> of <strong>{pageCount}</strong>
      </span>

      <IconButton
        style={{
          padding: 4,
          backgroundColor: sa.color.white,
          borderRadius: 0,
          cursor: 'pointer',
        }}
        onClick={() => onPageChange(pageNo - 1, pageSize)}
        disabled={pageNo === 1}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        style={{
          padding: 4,
          backgroundColor: sa.color.white,
          borderRadius: 0,
          cursor: 'pointer',
        }}
        onClick={() => onPageChange(pageNo + 1, pageSize)}
        disabled={pageNo === pageCount}
      >
        <ChevronRight />
      </IconButton>
    </Bar>
  );
};

export default Paging;
